import React, {useState, useEffect, useRef} from "react";
import OwlCarousel from 'react-owl-carousel2';
import sanityClient from "@sanity/client";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import InverseSlide from "./inverseSlide";
import * as styles from './inverseSlider.module.css';
import { gsap, TweenMax, Expo } from "gsap";

let owlClass = "inverse-owl " + styles.sliderWrap;

function InverseSlider(props) {

    let options = {
        items: 1,
        nav: false,
        dots: true,
        autoplay: false,
        margin: 10,
        loop: false,
        freeDrag : false,
        smartSpeed : 600,
        responsive : {
            0 : {
                items: 1
            },
            900 : {
                mouseDrag: false,
                pullDrag: false
            }
        }
    };

    if(props.slides.length > 1){
        options = {
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000,
            autoplaySpeed : 600,
            margin: 10,
            loop: true,
            freeDrag : true,
            smartSpeed : 600,
            responsive : {
                0 : {
                    items: 1
                }
            }
        };
    }

    let bgImageDesktop = (props.bgimage) ? props.bgimage.image.asset.url : false;
    
    const sectionRef = useRef();
    const owlRef = useRef();
    const bgRef = useRef();
    const mobileRef = useRef();

    useEffect(() => {

        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        if(props.slides.length > 1){
            let owl = $(owlRef.current);
            let currentIndex = 0;
            let isBusy = false;

            // TweenMax.set([$('.'+styles.siBulletContent), $('.'+styles.siContentWrap+' h3'), $('.'+styles.ctalink), $(mobileRef.current)], {
            //     x : 80,
            //     opacity : 0
            // });

            if(!$(sectionRef.current).hasClass('anim-complete')){
                $(window).on('scroll', () => {
                    if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                        let $el = owl.find('.owl-item.active');
                        // TweenMax.to($el.find('.'+styles.siContentWrap+' h3'), 0.45, {
                        //     x : 0,
                        //     opacity : 1,
                        //     delay: 0.25
                        // });
                        // TweenMax.to($el.find('.'+styles.siBulletContent), 0.45, {
                        //     x : 0,
                        //     opacity : 1,
                        //     delay: 0.5
                        // });
                        // TweenMax.to($(mobileRef.current), 0.45, {
                        //     x : 0,
                        //     opacity : 1,
                        //     delay: 0.5
                        // });
                        // TweenMax.to($el.find('.'+styles.ctalink), 0.45, {
                        //     x : 0,
                        //     opacity : 1,
                        //     delay: 0.75,
                        //     onComplete : () => {
                        //         $(sectionRef.current).addClass('anim-complete');
                        //     }
                        // });

                        $(sectionRef.current).addClass('anim-complete');
                        
                        let scroll_factor = 5;
                        let scroll_limit = 135;
                        let ref_offset = $(sectionRef.current).offset();
                        let scroll_pos = $(window).scrollTop();
            
                        if(ref_offset){
                            if(scroll_pos > (ref_offset.top - $(window).height()) ){
                                let move_by = ((scroll_pos - ref_offset.top) / scroll_factor);
                                move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;
            
                                TweenMax.to(bgRef.current, 0.25, {
                                    y : 0 - move_by
                                });
                            }
                        }
                    }
                });
            }

            owl.on('changed.owl.carousel', function (e) {
                currentIndex = e.relatedTarget.current()
                let $el = owl.find('.'+styles.inverseSlideItem).eq(e.relatedTarget.current());

                TweenMax.set([$el.find('.'+styles.siBulletContent), $el.find('.'+styles.siContentWrap+' h3'), $el.find('.'+styles.ctalink)], {
                    x : 80,
                    opacity : 0
                });
            
                TweenMax.to($el.find('.'+styles.siContentWrap+' h3'), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.25
                });
                TweenMax.to($el.find('.'+styles.siBulletContent), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.5
                });
                TweenMax.to($el.find('.'+styles.ctalink), 0.45, {
                    x : 0,
                    opacity : 1,
                    delay: 0.75
                });
            })

            // owl.on('mousewheel', '.owl-stage', function (e) {
                
            //     if(currentIndex < (props.slides.length - 1) && currentIndex > 0){
            //         e.preventDefault();
            //     }

            //     if(!isBusy){
            //         isBusy = true;
            //         if (e.originalEvent.deltaY>0) {
            //             let next = currentIndex+1;
            //             if(next <= (props.slides.length - 1)){
            //                 owl.find('.owl-dot').eq(next).click();
            //                 e.preventDefault();
            //             }
            //         } else {
            //             let prev = currentIndex-1;
            //             if(prev >= 0){
            //                 owl.find('.owl-dot').eq(prev).click();
            //                 e.preventDefault();
            //             }
            //         }
            //         setTimeout(() => {
            //             isBusy = false;
            //         }, 700);
            //     } else {
            //         e.preventDefault();
            //     }
                
            // });
        }
    });

    return (
        <div className={styles.sectionInverseSlider} ref={sectionRef}>

            {
                (bgImageDesktop) ?
                    <div className={styles.sectionBackground} style={{ backgroundImage : `url("${bgImageDesktop}")`}} ref={bgRef}></div>
                    : ``
            }

            <div className={styles.sectionContent}>
                <div className={styles.sectionContainer}>
                    <h3 className={styles.sectionHeading}>{props.label}</h3>
                    <div className={owlClass} ref={owlRef}>

                        <OwlCarousel options={options}>

                            {
                                props.slides.map((item, i) => {  
                                    return <InverseSlide item={item} key={i} appStore={props.appstore} googlePlay={props.googleplay} index={i} />
                                })
                            }

                        </OwlCarousel>

                    </div>
                    
                    <div className={styles.mobileSlides} ref={mobileRef}>

                        {
                            props.slides.map((item, i) => {  
                                return (
                                    <div className={styles.mobileSlideItem} key={i}>
                                        <div className={styles.msiImageWrap}>
                                            {
                                                (item.image) ?
                                                <img src={item.image.image.asset.url} alt={item.title} />
                                                : ``
                                            }
                                        </div>
                                        <div className={styles.msiBulletContent}>
                                            <div className={styles.msiBullet}>
                                                <span>{(i+1)}.</span>
                                            </div>
                                            <div className={styles.richtext}>
                                                <h5>{item.heading}</h5>
                                                <PortableText blocks={item.desc} />
                                            </div>
                                        </div>
                                        {
                                            (item.ctalink && i == (props.slides.length - 1)) ? 
                                                <div className={styles.msiSectionCTA}>
                                                    <a href={item.ctalink} className={styles.mobilectalink}>
                                                        <span>{item.ctalabel}</span>
                                                    </a>
                                                </div>
                                            : ``
                                        }
                                    </div>
                                );
                            })
                        }

                    </div>

                </div>
            </div>
        </div>
    );
}
  
export default InverseSlider;